export function formatDate(timestamp) {
    const date = new Date(Number(timestamp) * 1000);
    return [
        date.getDate(), date.getMonth() + 1, date.getFullYear()
    ].join('/');
}
